/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.payments.payment.method.management.rpc.PaymentMethodOnFileReadService
 */

export const getActivePaymentMethodOnFileListForContactRpc = {
  serviceName: 'com.hubspot.payments.payment.method.management.rpc.PaymentMethodOnFileReadService',
  rpcName: 'getActivePaymentMethodOnFileListForContact',
  auth: 'app',
  fingerprint: '0s151hVkmorPsRh7zulkhA0XcZFz_8jN',
  na1Only: false,
  isStreaming: false
};